import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.REACT_APP_CORE_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})
export const http = instance
